import { dimensions } from 'gazelle/src/core/analytics/ga-custom-defs';

export const name = 'RedirectController';

/**
 * Provides for redirecting into PrintOS with analytics configured
 * and for the locale cooke to be set by rhino.
 */
export default function RedirectController(
  $state,
  $stateParams,
  $location,
  $window,
  rnClient,
  $analytics
) {
  'ngInject';

  let myParams = {};

  activate();

  ////////////////////////

  function activate() {
    parseParams();
    configureEntityAnalytics();
    goToTargetUrl();
  }

  function parseParams() {
    let urlParams = $location.search();

    myParams.data = $stateParams.data;
    if (urlParams.target) {
      _.set(myParams, 'data.target.url', $window.decodeURIComponent(urlParams.target));
    }
  }

  function goToTargetUrl() {
    let target = _.get(myParams, 'data.target.url');
    if (!target) {
      // Redirect to sign-in without a valid target
      return $state.go('signin');
    }

    $window.location.href = target;
  }

  function configureEntityAnalytics() {
    return rnClient.getConfig()
      .then(clientConfig => {
        if (!clientConfig) {
          return;
        }

        let entity = clientConfig.entity;
        if (!entity) {
          return;
        }

        $analytics.setUsername(entity.id);

        // Set custom dimension1 for entity id (UID)
        $window.ga('set', dimensions.uid, entity.id);

        // Set custom dimension2 for organization id (ORGID)
        $window.ga('set', dimensions.orgId, clientConfig.context.id);

        // Set custom dimension3 for hpinternal (Use string, not Boolean "true" or "false")
        // Currently not available through client config (recommend import data outside of UI)
        //$window.ga('set', dimensions.hpInternal, hpInternal);

        // Set custom dimension4 for user role names
        // Currently not available through client config (recommend import data outside of UI)
        //if (rolesString) {
        //  $window.ga('set', dimensions.roles, rolesString);
        //}

        // Set custom dimension5 for organization type
        // Currently not available through client config (recommend import data outside of UI)
        //$window.ga('set', dimensions.orgType, orgType);

        // Set custom dimension6 for selfProvisioned (Use string, not Boolean "true" or "false")
        //$window.ga('set', dimensions.selfProvisioned, selfProvisioned);

        // Set custom dimension7 for the entity type (ENTITY TYPE)
        $window.ga('set', dimensions.entityType, entity.type);

        let target = _.get(myParams, 'data.target.url');
        $analytics.eventTrack('redirect', {category: 'account', label: target});
      });
  }
}



// WEBPACK FOOTER //
// ./components/redirect/redirect.controller.js